import {ToastRegion} from '@wandb/components';
import React from 'react';

import {TOP_NAV_HEIGHT} from '../util/constants';
import {useForgeNavbarHeight} from '../util/hooks/useForgeNavbarHeight';

/**
 * The `@wandb/components` toast region, pushed below whatever the page sits
 * under: the app navbar standalone, or the Forge shell header plus any banner
 * above it. The shell publishes that height as `--forge-navbar-height`
 * (services/shell/src/styles.css); standalone leaves it unset, so the navbar
 * height applies. The react-toastify container is positioned by
 * `--wb-toast-top-margin` in src/css/layout-tokens.css instead.
 */
export const AppToastRegion = () => {
  const offsetY = useForgeNavbarHeight(TOP_NAV_HEIGHT);
  return <ToastRegion offsetY={offsetY} />;
};
